import client from './client';
/**
 * 키워드별 통계
 */
export const KeywordStatistics = (param) =>
  client.get(`/api/report/keyword`, param);

/**
 * 광고주별 수집현황
 */
export const keywordStatusStatistics = (param) =>
  client.get(`/api/report/keyword/status`, param);

/**
 * 유입키워드 수집여부 수정
 */
export const toggleCollect = (param) =>
  client.post(`/api/report/keyword/useToggle`, param);

/**
 * 키워드통계 광고주별 상세
 */
export const keywordAdverDetail = (param) =>
  client.get(`/api/report/keyword/detail`, param);

/**
 * 키워드통계 광고주별 상세내 키워드그룹
 */
export const keywordGroup = (param) => {
  return client.get(`/api/report/keyword/detail/group`, { params: param });
};
